import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FullScreenService } from './fullscreen.service';
@NgModule({
    imports: [CommonModule],
    providers: [FullScreenService]
})
export class FullScreenModule {}
